import { useTranslation } from "react-i18next";

export default function AboutMission() {
  const { t } = useTranslation();
  return (
    <section className="py-20">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          {/* Text */}
          <div>
            <span
              className="inline-block text-xs font-semibold uppercase tracking-widest mb-4 px-3 py-1 rounded-full"
              style={{ backgroundColor: "rgba(34,197,94,0.1)", color: "var(--accent)" }}
            >
              {t("about.mission.label")}
            </span>
            <h2 className="text-3xl md:text-4xl font-bold leading-tight mb-5" style={{ color: "var(--text-primary)" }}>
              {t("about.mission.title")}
            </h2>
            <p className="text-sm leading-relaxed mb-4" style={{ color: "var(--text-muted)" }}>
              {t("about.mission.p1")}
            </p>
            <p className="text-sm leading-relaxed mb-4" style={{ color: "var(--text-muted)" }}>
              {t("about.mission.p2")}
            </p>
            <p className="text-sm leading-relaxed" style={{ color: "var(--text-muted)" }}>
              {t("about.mission.p3")}
            </p>
          </div>

          {/* Image */}
          <div className="w-full h-[320px] rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=modern%20open%20office%20diverse%20software%20engineering%20team%20collaborating%20on%20laptops%20screens%20bright%20natural%20light%20green%20plants%20minimalist%20workspace%20tech%20startup%20vibe&width=640&height=320&seq=about-mission-001&orientation=landscape"
              alt={t("about.mission.title")}
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}